import { Component, ViewChild } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GraphQLError } from 'graphql';
import { CurrentUserQuery, UserFieldsFragment, UsersGQL, UsersQuery, UsersExportGQL, UserFilterContainer } from 'src/app/graphql/gql';
import { ColumnDefinition } from 'src/app/paginated-table/paginated-table.component';
import { DataMapperResult } from 'src/app/paginated-table/table-data-source';
import { FILTER_DEFINITIONS } from './users-filter-defs';
import {Router} from "@angular/router"
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  standalone: false
})
export class UsersComponent {
  @ViewChild('usersTable') table!: any;

  loading = true;
  data!: CurrentUserQuery;
  errors: readonly GraphQLError[] | undefined;

  selection: UserFieldsFragment[] = []
  selectAll = false
  filterQueryParameter: UserFilterContainer | null = null

  columns: ColumnDefinition[] = [
    {
      attr: 'account.company',
      label: $localize`:users|Account company column:Account Company`,
      visible: false,
      orderKey: 'account_company'
    },
    {
      attr: 'account.clientNumber',
      label: $localize`:users|Account client number column:Account Client Number`,
      orderKey: 'account_client_number'
    },
    {
      attr: 'login',
      label: $localize`:users|Login name column:Login Name`,
      orderKey: 'login'
    },
    {
      attr: 'email',
      label: $localize`:users|Email column:Email`,
      orderKey: 'email'
    },
    {
      attr: 'firstname',
      label: $localize`:users|First name column:First Name`,
      orderKey: 'firstname'
    },
    {
      attr: 'lastname',
      label: $localize`:users|Last name column:Last Name`,
      orderKey: 'lastname'
    },
    {
      attr: 'state',
      label: $localize`:users|State column:State`,
      orderKey: 'state'
    },
    {
      attr: 'company',
      label: $localize`:users|Company column:Company`,
      visible: false,
      orderKey: 'company'
    },
    {
      attr: 'street',
      label: $localize`:users|Street column:Street`,
      visible: false,
      orderKey: 'street'
    },
    {
      attr: 'zip',
      label: $localize`:users|ZIP column:ZIP`,
      visible: false,
      orderKey: 'zip'
    },
    {
      attr: 'city',
      label: $localize`:users|City column:City`,
      visible: false,
      orderKey: 'city'
    },
    {
      attr: 'country',
      label: $localize`:users|Country column:Country`,
      visible: false,
      orderKey: 'country'
    },
    {
      attr: 'country_state',
      label: $localize`:users|Country state column:Country State`,
      visible: false
    },
    {
      attr: 'other_state',
      label: $localize`:users|Other state column:Other State`,
      visible: false,
      orderKey: 'other_state'
    },
    {
      attr: 'phone',
      label: $localize`:users|Phone column:Phone`,
      visible: false,
      orderKey: 'phone'
    },
    {
      attr: 'fax',
      label: $localize`:users|Fax column:Fax`,
      visible: false,
      orderKey: 'fax'
    },
    {
      attr: 'cell_phone',
      label: $localize`:users|Cell phone column:Cell Phone`,
      visible: false,
      orderKey: 'cell_phone'
    },
    {
      attr: 'last_sign_in_at',
      label: $localize`:users|Last sign in column:Last Sign In At`,
      orderKey: 'last_sign_in_at'
    },
    {
      attr: 'commercial_register_number',
      label: $localize`:users|Commercial register number column:Commercial Register Number`,
      visible: false,
      orderKey: 'commercial_register_number'
    },
    {
      attr: 'tax_number_company',
      label: $localize`:users|Tax number company column:Tax Number Company`,
      visible: false,
      orderKey: 'tax_number_company'
    },
    {
      attr: 'client_number',
      label: $localize`:users|Client number column:Client Number`,
      visible: false,
      orderKey: 'client_number'
    }
  ]
  filters = FILTER_DEFINITIONS

  rowMenuItems: MenuItem[] = [
    {
      label: $localize`:menu|header:Action`,
      items: [
        { label: $localize`:menu|action:Edit`, icon: 'pi pi-user-edit', command: () => { this.redirectToEditUser() } },
      ]
    }
  ];

  constructor(
    private apollo: Apollo,
    private router: Router,
    public usersGQL: UsersGQL,
    public usersExport: UsersExportGQL,
  ) {}

  dataMapper(data: UsersQuery): DataMapperResult<UserFieldsFragment> {
    return {
      items: data.users!.edges!.map(edge => edge!.node!),
      totalCount: data.users!.totalCount || null
    }
  }

  onUserClick(user: any) {
    console.log(user)
  }

  onSelectionChange(selection: UserFieldsFragment[]) {
    this.selection = selection
  }

  onSelectAllChange(selectAll: boolean) {
    this.selectAll = selectAll
  }

  onFilterQueryParameterChange(filterQueryParameter: UserFilterContainer | null) {
    this.filterQueryParameter = filterQueryParameter
  }

  redirectToEditUser() {
    const userId = this.table.currentRowMenuItem.id;
    this.router.navigate(['/reseller/users', userId, 'edit']);
  }

  onCreateUserClick() {
    this.router.navigate(['/reseller/users/new']);
  }

  onExportClick() {
    this.usersExport.fetch({
      ids: (this.selectAll || this.selection.length == 0) ? null : this.selection.map(o => o.id),
      filter: this.filterQueryParameter
    }).subscribe({
      next: (response) => {
        const csvData = response.data.usersExport
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'users-export-' + new Date().toISOString() + '.csv'
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
      }
    });
  }
}
